import { render, staticRenderFns } from "./component-be3cb184.vue?vue&type=template&id=2d878786&scoped=true&"
import script from "./component-be3cb184.vue?vue&type=script&lang=js&"
export * from "./component-be3cb184.vue?vue&type=script&lang=js&"
import style0 from "./component-be3cb184.vue?vue&type=style&index=0&id=2d878786&lang=scss&scoped=true&"
import style1 from "./component-be3cb184.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d878786",
  null
  
)

export default component.exports